module.exports = __webpack_public_path__ + "static/fonts/iconfont.0779f946.woff";